<template>
  <section id="promotions"
    class="relative overflow-hidden z-10 h-full pt-24 pb-48 sm:pb-64 md:pb-72 lg:pb-[26vw] bg-gradient-to-r from-[#737DD8] via-[#737DD8] to-[#737DD8]">
    <img src="../assets/circle.png" alt="Circle 1"
      class="absolute top-[80px] -left-[100px] w-[480px] h-[480px] rounded-full object-contain" />

    <div
      class="absolute top-[240px] md:top-[100px] -left-[140px] md:-left-[300px] w-full h-[900px] md:w-[600px] md:h-[500px] rounded-full bg-[#F25960] opacity-10 blur-2xl">
    </div>
    <div
      class="absolute top-[240px] md:top-[100px] -right-[140px] md:-right-[300px] w-full h-[900px] md:w-[600px] md:h-[500px] rounded-full bg-[#F25960] opacity-10 blur-2xl">
    </div>




    <div class="relative px-4 mx-auto sm:max-w-4xl lg:max-w-6xl 2xl:max-w-7xl">
      <div class="flex flex-col items-center justify-center gap-2">
        <h2 v-motion-pop-visible class="mb-6 text-4xl font-bold text-center text-white md:text-6xl font-montserrat"
          style="font-family: Montserrat, sans-serif; text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);">
          REWARDS AND PROMOS
        </h2>
      </div>

      <!-- Promo Card -->
      <div v-motion-pop-visible class="flex flex-col items-center justify-center w-full sm:mt-10">
        <div
          class="relative z-20 flex flex-col items-center justify-center lg:justify-start lg:items-start w-full max-w-[340px] md:max-w-[420px] lg:max-w-[1200px] pb-10 lg:pt-0 overflow-hidden text-center bg-center bg-no-repeat bg-cover lg:pb-0 lg:bg-contain bg-promo-bg-sm lg:bg-promo-bg">
          <!-- Content -->
          <div class="relative z-10 px-6 pt-6 md:pt-4 lg:pt-10 lg:px-10">
            <div class="flex flex-col items-center lg:flex-row md:gap-x-6">
              <h2 class="text-2xl md:text-3xl font-bold text-white font-montserrat lg:text-[42px] 2xl:text-5xl">
                REGISTER NOW ON
              </h2>
              <img src="@/assets/promo-stake-ceo.png"
                class="w-[180px] md:w-[220px] lg:w-[200px] h-[100px] md:h-[130px] lg:h-[110px]" alt="promo stake" />
            </div>

            <!-- Promo Details -->
            <div class="flex flex-col mt-6 md:gap-8 lg:gap-0 lg:mt-0">
              <ul
                class="flex flex-col py-4 text-sm text-left text-white list-disc list-inside lg:text-base xl:text-lg gap-y-4 lg:gap-y-0 xl:gap-y-2 lg:text-left font-montserrat">
                <li>
                  Double Weekly (Thursday by me - Saturday by Stake) + Affiliate
                  Race
                </li>
                <li>
                  Sign up account by clean link with code
                  <a href="https://stake.ceo/?c=6e8cc74d&offer=hanvee" class="text-[#F25960] font-bold" target="_blank"
                    rel="noopener noreferrer">
                    HANVEE
                  </a>
                  at
                  <a href="https://stake.ceo/?c=6e8cc74d&offer=hanvee" class="text-[#F25960] font-bold" target="_blank"
                    rel="noopener noreferrer">
                    stake.ceo
                  </a>
                </li>
                <li>
                  <strong class="text-[#F25960]">200%</strong> Deposit Bonus -
                  minimum of $100 and maximum of $1,000
                </li>
                <li>
                  Register now and use code
                  <a href="https://stake.ceo/?c=6e8cc74d&offer=hanvee" class="text-[#F25960] font-bold" target="_blank"
                    rel="noopener noreferrer">
                    HANVEE200
                  </a>
                </li>
              </ul>

              <div
                class="w-full lg:max-w-[400px] max-h-[100px] py-8 md:py-4 px-4 lg:py-0 lg:h-full lg:pb-32 lg:pt-2 lg:px-0">
                <!-- Wrapper for Existing Button -->
                <div class="flex items-center justify-center lg:justify-start h-[60px] rounded-full lg:py-4">
                  <div
                    class="relative h-[72px] w-full md:w-[300px] rounded-full bg-gradient-to-b from-[#FF252F] to-[#A62AFF]
                    transition-shadow duration-200 hover:shadow-[0_0_20px_4px_rgba(255,37,47,0.7),0_0_20px_4px_rgba(166,42,255,0.7)]">
                    <div
                      class="absolute inset-0 m-[2px] rounded-full bg-white overflow-hidden flex items-center justify-center">
                      <a href="https://stake.ceo/?c=6e8cc74d&offer=hanvee"
                        class="z-10 px-14 py-6 text-md font-bold text-[#090B2A] text-center whitespace-nowrap"
                        style="font-family: Lato, sans-serif;">
                        REGISTER ON STAKE.CEO
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img src="../assets/footer-bg.png" alt="footer-bg"
      class="absolute -bottom-[40px] md:-bottom-[100px] lg:-bottom-[180px] h-[34vw] left-0 object-contain" />

  </section>
</template>

<script>
import { ref } from 'vue';

export default {
  data() {
    return {
      hoveredButton1: ref(false),
    };
  },
};
</script>
